// extracted by mini-css-extract-plugin
export default {"root":"DiscountLabel__root--2aLAh"};